export default __webpack_public_path__ + "static/media/mv.61179d1f.svg";